import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.ptpit.ru/acceptance',
});
